import React from "react";
import cn from "classnames";
import styles from "./Row.module.sass";
import ListTokenStore from "./ListTokenStore";
import Modal from "../../../../components/Modal";
import tWallet from "../../../../i11/TokenWallet";
import Actions from "../../../../components/Actions";
import Confirm from "../../../../components/Confirm";

import { useUser } from "../../../../context";
import { UseApi } from "../../../../hooks/use-api";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import { PatchListToToken } from "../../../../Services/lib/admin";

const Row = ({ item, open, getData }) => {
	const { locale } = useUser();

	const [{ isLoading }, listToToken] = UseApi({
		service: PatchListToToken,
		successMsg: "Success",
	});
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: isOpenUndo,
		onClose: onCloseUndo,
		onOpen: onOpenUndo,
	} = UseDisclosure();

	const actionsPublished = [
		{
			title: item.isOnSale
				? tWallet[locale].undo_list
				: tWallet[locale].list_token_store,
			icon: item.isOnSale ? "repeat" : "ticket",
			action: item.isOnSale ? onOpenUndo : onOpen,
		},
	];

	const edit_ = () => {
		open(item);
	};

	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}>
					<div onClick={edit_} className={styles.name}>
						<div className={styles.img}>
							<img src={item.image} alt={item.name} />
						</div>
						<div>
							<div>
								{/* {isHot && <Icon name="star-fill" />} */}
							</div>
							<div>{item.name}</div>
						</div>
					</div>
				</div>
				<div className={styles.col}>{item.smartContract}</div>
				<div className={styles.col}>{item.tokenType}</div>
				<div className={cn(styles.col)}>
					{
						tWallet[locale][
							item.tradeInSize ? "trade_in" : "direct_mint"
						]
					}
				</div>
				<div className={cn(styles.col)}>
					<div className={styles.actioncol}>
						{
							tWallet[locale][
								item.isOnSale
									? "on_sale"
									: item.rafflesSize
									? "prize"
									: "na"
							]
						}
					</div>
				</div>
				<div className={styles.col}>{item.createdAt}</div>

				<div className={cn(styles.col)}>
					{/* {item.isOnSale === false && item.rafflesSize ? (
						<></>
					) : (
						<Actions
							classActionsOption={styles.classActionsOption}
							classActionsHead={styles.actionsHead}
							classActionsBody={styles.actionsBody}
							items={actionsPublished}
						/>
					)} */}
				</div>
			</div>
			<Modal
				outSideClickNone
				outerClassName={styles.modal}
				visible={isOpen}
				onClose={onClose}
			>
				{isOpen && (
					<ListTokenStore
						onClose={onClose}
						item={item}
						getData={getData}
					/>
				)}
			</Modal>

			<Modal visible={isOpenUndo} onClose={onCloseUndo}>
				<Confirm
					title={tWallet[locale].undo_list}
					onCancel={onCloseUndo}
					onConfirm={async () => {
						const res = await listToToken({
							isOnSale: false,
							saleType: "SALE",
							_id: item._id,
						});
						if (res) {
							onCloseUndo();
							getData();
						}
					}}
					isLoading={isLoading}
				></Confirm>
			</Modal>
		</>
	);
};

export default Row;
